export default __webpack_public_path__ + "static/media/filter-status-close.e7128b77.svg";